import vue from "../main";

export default function(id) {
  let result = vue.$store.dispatch("confirmDialog", {
    content: vue.$t("travelService.separateTravelServiceDialog.content"),
    title: vue.$t("travelService.separateTravelServiceDialog.title")
  });
  result.then(() => {
    vue.axios.post("/travel-service/separate-travel-service", { travelServiceId: id }).then(() => {
      vue.$store.dispatch("snackbarPush", {
        text: vue.$t("global.saved"),
        position: "down"
      });
      vue.$router.push("/travel-service");
    });
  });
}
